import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRoute, Router, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})

export class NewVersionService implements CanActivate {

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private http: HttpClient
  ) { }

  private apiUrl = 'baseConfig/webProjectPath'; // Define your API endpoint here

  getWebProjectPath(): Observable<string> {
    return this.http.get<string>(this.apiUrl);
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {


    var year = parseInt(route.params.year);
    const isNewVersion = year >= 2021;

    return isNewVersion;

  }

}
